export const SET_SENDER_DETAILS = "SET_SENDER_DETAILS";
export const SET_RECIVER_DETAILS = "SET_RECIVER_DETAILS";
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const NEW_ADDRESS_DETAILS = "NEW_ADDRESS_DETAILS";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_BUSINESS_LIST = "SET_BUSINESS_LIST";
export const SET_SELECTED_BUSINESS = "SET_SELECTED_BUSINESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
